<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>批次流向查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchNo">
                <el-input v-model.trim="searchform.batchNo" style="width:100%" clearable placeholder="请输入批次号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker style="width: 100%" v-model="searchform.datelist" :clearable="false" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['boxcode_select']">搜索</el-button>
              <!-- <el-button v-permission="['boxcode_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>批次流向查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="tableLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="batchNo" label="批次" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productCode" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerCode" label="经销商编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="经销商名称" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualBatchQuantity" label="实际出库数量" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="scanBatchQuantity" label="扫码数量" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="address" label="经销商地址" min-width="100" show-overflow-tooltip></el-table-column>

            <el-table-column prop="fromWarehouseCode" label="仓库编码" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="fromWarehouse" label="仓库名称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outBillDate" label="出库日期" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination background layout="total,prev, pager, next, jumper, sizes" :total="pageTotal"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchform.pageSize"
            :current-page.sync="searchform.pageIndex" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findDirection } from "@/api/physical";
export default {
  mounted() {
    this.search()
  },
  data() {
    return {
      //基础数据
      tableLoading: false,
      tableData: [],
      //分页数据
      pageTotal: 0,
      //搜索表单数据
      searchform: {
        batchNo: null,
        datelist: [],
        pageSize: 10,
        pageIndex: 1,
      },
    };
  },
  methods: {
    //请求表格数据
    fetchTableData() {
      this.tableLoading = true;
      this.searchform.startTime = this.searchform.datelist.length ? this.searchform.datelist[0] : '';
      this.searchform.endTime = this.searchform.datelist.length ? this.searchform.datelist[1] : '';
      findDirection(this.searchform).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.currentPage = response.data.currPage;
        this.pageTotal = response.data.totalCount;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    // 拼装列表数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
      }
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.tableData = [];
      this.pageTotal = 0;
      this.searchform.pageIndex = 1;
      this.searchform.pageSize = 10;
      this.search();
    },
    //搜索事件
    search() {
      this.searchform.pageIndex = 1;
      this.fetchTableData();
    },
    //分页跳转事件
    handleCurrentChange(val) {
      this.fetchTableData();
    },
    //分页每页显示条数事件
    handleSizeChange(val) {
      this.fetchTableData();
    },

  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>